// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Common = require("../utils/Common.res.js");
var MM_context = require("../mm-utils/MM_context.res.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.res.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");

function prepareParenInts(wrkCtx, parenStr) {
  var parenSyms = Common.getSpaceSeparatedValuesAsArray(parenStr);
  var parenInts = [];
  var maxI = (parenSyms.length / 2 | 0) - 1 | 0;
  for(var i = 0; i <= maxI; ++i){
    var leftParen = parenSyms[(i << 1)];
    var rightParen = parenSyms[(i << 1) + 1 | 0];
    var leftParenInt = MM_context.ctxSymToInt(wrkCtx, leftParen);
    if (leftParenInt !== undefined && MM_context.isConst(wrkCtx, leftParen)) {
      var rightParenInt = MM_context.ctxSymToInt(wrkCtx, rightParen);
      if (rightParenInt !== undefined && MM_context.isConst(wrkCtx, rightParen)) {
        parenInts.push(leftParenInt);
        parenInts.push(rightParenInt);
      }
      
    }
    
  }
  return parenInts;
}

function lineToVarDef(line) {
  var arr = Common.getSpaceSeparatedValuesAsArray(line);
  if (arr.length !== 3) {
    return {
            TAG: "Error",
            _0: "A line representing a variable definition should consist of exactly three parts separated with a whitespace."
          };
  } else {
    return {
            TAG: "Ok",
            _0: arr
          };
  }
}

function textToVarDefs(text) {
  var varLines = Common.multilineTextToNonEmptyLines(text);
  if (varLines.length === 0) {
    return {
            TAG: "Ok",
            _0: []
          };
  } else {
    return Core__Array.reduce(varLines, {
                TAG: "Ok",
                _0: []
              }, (function (res, line) {
                  if (res.TAG !== "Ok") {
                    return res;
                  }
                  var varDefs = res._0;
                  var msg = lineToVarDef(line);
                  if (msg.TAG !== "Ok") {
                    return {
                            TAG: "Error",
                            _0: msg._0
                          };
                  }
                  varDefs.push(msg._0);
                  return {
                          TAG: "Ok",
                          _0: varDefs
                        };
                }));
  }
}

function createWrkCtx(preCtx, varsText, disjText) {
  var wrkCtx = MM_context.createContext(Caml_option.some(preCtx), undefined);
  var err = Core__Array.reduce([
        (function () {
            var msg = textToVarDefs(varsText);
            if (msg.TAG === "Ok") {
              try {
                msg._0.forEach(function (varDef) {
                      MM_context.applySingleStmt(wrkCtx, {
                            TAG: "Var",
                            symbols: [varDef[2]]
                          }, undefined, undefined, undefined, undefined);
                      MM_context.applySingleStmt(wrkCtx, {
                            TAG: "Floating",
                            label: varDef[0],
                            expr: [
                              varDef[1],
                              varDef[2]
                            ]
                          }, undefined, undefined, undefined, undefined);
                    });
                return ;
              }
              catch (raw_exn){
                var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                if (exn.RE_EXN_ID === Common.MmException) {
                  var init = {
                    varsErr: undefined,
                    disjErr: undefined
                  };
                  return {
                          varsErr: exn._1.msg,
                          disjErr: init.disjErr
                        };
                }
                throw exn;
              }
            } else {
              var init$1 = {
                varsErr: undefined,
                disjErr: undefined
              };
              return {
                      varsErr: msg._0,
                      disjErr: init$1.disjErr
                    };
            }
          }),
        (function () {
            try {
              Common.multilineTextToNonEmptyLines(disjText).forEach(function (__x) {
                    MM_context.applySingleStmt(wrkCtx, {
                          TAG: "Disj",
                          vars: __x.split(" ").map(function (__x) {
                                  return __x.trim();
                                }).filter(function (str) {
                                return str !== "";
                              })
                        }, undefined, undefined, undefined, undefined);
                  });
              return ;
            }
            catch (raw_exn){
              var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
              if (exn.RE_EXN_ID === Common.MmException) {
                var init = {
                  varsErr: undefined,
                  disjErr: undefined
                };
                return {
                        varsErr: init.varsErr,
                        disjErr: exn._1.msg
                      };
              }
              throw exn;
            }
          })
      ], undefined, (function (err, nextStep) {
          if (err !== undefined) {
            return err;
          } else {
            return nextStep();
          }
        }));
  if (err !== undefined) {
    return {
            TAG: "Error",
            _0: err
          };
  } else {
    return {
            TAG: "Ok",
            _0: wrkCtx
          };
  }
}

exports.prepareParenInts = prepareParenInts;
exports.textToVarDefs = textToVarDefs;
exports.createWrkCtx = createWrkCtx;
/* Common Not a pure module */
